module.exports = __webpack_public_path__ + "img/josh.13ac6a2a.png";